import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=effc8c60&scoped=true"
import script from "./Billing.ts?vue&type=script&lang=ts&external"
export * from "./Billing.ts?vue&type=script&lang=ts&external"
import style0 from "./Billing.vue?vue&type=style&index=0&id=effc8c60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effc8c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('effc8c60')) {
      api.createRecord('effc8c60', component.options)
    } else {
      api.reload('effc8c60', component.options)
    }
    module.hot.accept("./Billing.vue?vue&type=template&id=effc8c60&scoped=true", function () {
      api.rerender('effc8c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/pages/Billing/Billing.vue"
export default component.exports